import type { ReactNode } from 'react';
import { useSwipeContext } from '../SwipeContext';
import { Grid, CrossSolid, Button } from '@simplywallst/ui-core';
import { StyledHeader } from './styled';

interface Props {
  children?: ReactNode;
  zIndex?: number;
}

export const Header = ({ children }: Props) => {
  const { onMouseDown, onTouchStart, onClose } = useSwipeContext();
  return (
    <StyledHeader
      as="header"
      templateRows="minmax(40px, max-content)"
      templateColumns="auto 40px"
    >
      <Grid
        justifyContent="left"
        alignContent="center"
        onMouseDown={onMouseDown}
        onTouchStart={onTouchStart}
      >
        {children}
      </Grid>
      <Grid justifyContent="center" alignContent="start">
        <Button
          type="button"
          styleType="passive"
          onClick={onClose}
          aria-label="Close"
          data-cy-id="action-sheet-close"
        >
          <CrossSolid />
        </Button>
      </Grid>
    </StyledHeader>
  );
};
